import React from 'react';
import type { User } from '../types';
import { closePermissionPreview } from '../services/permissionPreviewSession';

export function PermissionPreviewBanner({ user }: { user: User | null }) {
  const es = user?.preferred_language === 'es';
  return <div role="status" className="sticky top-0 z-[10000] flex flex-wrap items-center justify-between gap-2 border-b border-orange-500/40 bg-[#382613] px-4 py-2 text-sm text-orange-100">
    <div><strong>{es ? 'Vista previa' : 'Preview'}{user ? ` · ${user.display_name || user.name || user.email}` : ''}</strong>
      <p className="text-xs">{es ? 'Solo lectura · Permisos sin guardar · Archivos y descargas no disponibles' : 'Read-only · Unsaved permissions · Files and downloads unavailable'}</p>
      {user?.permission_preview?.limited_to_manager && <p className="text-xs">{es ? 'Limitada a los datos que tú tienes permiso de consultar.' : 'Limited to data you have permission to view.'}</p>}
    </div>
    <button type="button" onClick={closePermissionPreview} className="rounded-lg border border-orange-300/40 px-3 py-1.5 font-semibold">{es ? 'Cerrar vista previa' : 'Close preview'}</button>
  </div>;
}
